import { PageLoading } from 'module/ui/components/atoms/loading';
import { AccountLayout } from './common/layout';
import { AccountsTabs, AccountsTabsType } from './common/tab';
import { useCompanyFromUrl } from './use-current-company';

export const AccountHome = () => {
  // const [activeKey, setActiveKey] = useState('tab1');

  return (
    <div>
      {/* <Button type="primary">Click me</Button>

      <Tabs items={tabs} activeKey={activeKey} onChange={setActiveKey} /> */}
    </div>
  );
};
export const AccountHomePage = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading || company == null ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.Home} />}
      content={<AccountHome />}
      actions={{}}
    />
  );
};
